<template>
  <owal-panel-header
    :top-attached="this.topAttached"
  >
    <h4 class="ui grey container">
      <slot />
    </h4>
  </owal-panel-header>
</template>

<script>
import OwalPanelHeader from '@/libraries/owal-ui/panels/OwalPanelHeader'

export default {
  name: 'HeaderSegment',
  components: { OwalPanelHeader },
  props: {
    topAttached: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style scoped>

</style>
